module.exports = __webpack_public_path__ + "img/membership-activated-male.4ad94e8.png";